// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chimney-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 21V11H9V21H21Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M3 21H9V11H11.4444L11 7L12 3H3L4 7L3 21Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15 17V21M4 7H11M4 7L3 21H9V11H11.4444L11 7M4 7L3 3H12L11 7","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 21V11H9V21H21Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Chimney1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chimney-1',
    ref,
    icon: element,
  },
));

Chimney1Icon.displayName = 'Chimney1Icon';

export default Chimney1Icon;
